import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import PreloaderSlice from './slices/preloaderSlice';

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    PreloaderSlice,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
